import { DashboardModules } from "shared/components/dashboard/dashboardMapper";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

export const CustomReportDashboardModules = () => {
  const { customReportResponse } = usePillarTableContext();

  if (!customReportResponse?.dashboardModules?.length) {
    return null;
  }
  return (
    <DashboardModules dashboards={customReportResponse?.dashboardModules} />
  );
};
